import React, { useState, useEffect, useContext } from "react";
import ProductsGrid from "./ProductsGrid";
import ProductList from "./ProductList";
import { useMediaQuery } from "@material-ui/core";
import styled from "styled-components";
import { breakpoints } from "@constants/styled-components";
import ListView from "../../../../assets/icons/ListView";
import GridView from "../../../../assets/icons/GridView";
import { addToCart } from "@actions/cart/addToCart";
import { addItemInShoppingList } from "@actions/shoppingList/addItemsToShoppingList";
import { useDispatch, useSelector } from "react-redux";
import AddItemToCart from "@pages/Cart/ShoppingCart/AddItemToCart";
import LoadingOverlay from "@common/LoadingOverlay";
import AddItemToShoppingList from "@pages/shoppingList/AddItemToShoppingList";
import {
  fetchmostPopularViewAll,
  mostPopularSelector,
  intitalizeLoader,
  fetchUpdatedParams,
} from "@slices/Promotions/mostPopular";
import Breadcrumb from "@fragments/Breadcrumb";

import { useGetLoggedInUserInfo } from "@hooks";
import { WebSettingsContext } from "@providers/WebsettingsProvider";

interface IProps {
  products: any;
  loading: boolean;
  hasErrors: boolean;
}

const MostPopularViewAll = (props: IProps) => {
  const dispatch = useDispatch();
  const [showAddToCart, setShowAddToCart] = useState<boolean>(false);
  const isMobile = useMediaQuery(`(max-width:${breakpoints.sm})`);
  const [listView, setListView] = useState(false);

  const sessionId = useGetLoggedInUserInfo();
  const webSettingsData: any = useContext(WebSettingsContext);
  const products = useSelector(mostPopularSelector);
  const loading = products.loading;

  const [productList, setProductList] = useState(
    products?.mostPopularViewAll?.map((item: any) => {
      const unit = item?.salesUnit ? item.salesUnit : item?.defaultSalesUnit;
      if (
        item?.itemNumberOfDecimalsAllowed !== null &&
        item?.itemNumberOfDecimalsAllowed !== undefined &&
        item?.salesUnits !== null &&
        item?.salesUnits !== undefined &&
        unit !== null &&
        unit !== undefined &&
        Number(item?.itemNumberOfDecimalsAllowed?.length) > Number(0) &&
        Number(item?.salesUnits?.length) > Number(0)
      ) {
        return {
          key: item?.code,
          quantity: 1,
          unit: unit,
          isCartDisable: false,
          itemNumberOfDecimalsAllowed:
            item?.itemNumberOfDecimalsAllowed[item?.salesUnits?.indexOf(unit)],
        };
      } else {
        return {
          key: item?.code,
          quantity: 1,
          unit: unit,
          isCartDisable: false,
        };
      }
    })
  );

  const quantityChangeHandler = (
    qty: number,
    index: number,
    isValid: boolean
  ) => {
    setProductList((prevState: any) => {
      const copyShowUnit = prevState ? [...prevState] : [{}];
      copyShowUnit[index] = {
        ...copyShowUnit[index],
        quantity: qty,
        isCartDisable: !isValid,
      };
      return copyShowUnit;
    });
  };
  const unitChangeHandler = (
    itemCode: string,
    selectedUnit: string,
    index: number
  ) => {
    const product = props?.products?.find((item: any) => {
      return item?.code === itemCode;
    });
    if (
      product?.itemNumberOfDecimalsAllowed !== null &&
      product?.itemNumberOfDecimalsAllowed !== undefined &&
      product?.salesUnits !== null &&
      product?.salesUnits !== undefined &&
      selectedUnit !== null &&
      selectedUnit !== undefined &&
      Number(product?.itemNumberOfDecimalsAllowed?.length) > Number(0) &&
      Number(product?.salesUnits?.length) > Number(0)
    ) {
      setProductList((prevState: any) => {
        const copyShowUnit = prevState ? [...prevState] : [{}];
        copyShowUnit[index] = {
          ...copyShowUnit[index],
          unit: selectedUnit,
          quantity: 1,
          itemNumberOfDecimalsAllowed:
            product?.itemNumberOfDecimalsAllowed[
              product?.salesUnits?.indexOf(selectedUnit)
            ],
        };
        return copyShowUnit;
      });
    } else {
      setProductList((prevState: any) => {
        const copyShowUnit = prevState ? [...prevState] : [{}];
        copyShowUnit[index] = { ...copyShowUnit[index], unit: selectedUnit };
        return copyShowUnit;
      });
    }

    dispatch(
      fetchUpdatedParams(encodeURIComponent(itemCode), sessionId?.sessionId, selectedUnit, index)
    );
  };

  useEffect(() => {
    setProductList(
      products?.mostPopularViewAll?.map((item: any) => {
        const unit = item?.salesUnit ? item.salesUnit : item?.defaultSalesUnit;
        if (
          item?.itemNumberOfDecimalsAllowed !== null &&
          item?.itemNumberOfDecimalsAllowed !== undefined &&
          item?.salesUnits !== null &&
          item?.salesUnits !== undefined &&
          unit !== null &&
          unit !== undefined &&
          Number(item?.itemNumberOfDecimalsAllowed?.length) > Number(0) &&
          Number(item?.salesUnits?.length) > Number(0)
        ) {
          return {
            key: item?.code,
            quantity: 1,
            unit: unit,
            isCartDisable: false,
            itemNumberOfDecimalsAllowed:
              item?.itemNumberOfDecimalsAllowed[
                item?.salesUnits?.indexOf(unit)
              ],
          };
        } else {
          return {
            key: item?.code,
            quantity: 1,
            unit: unit,
            isCartDisable: false,
          };
        }
      })
    );
  }, [products]);

  useEffect(() => {
    dispatch(intitalizeLoader());
    dispatch(fetchmostPopularViewAll());
  }, [dispatch, sessionId?.sessionId ]);

  const addItemToCartHandler = (
    sessionId: any,
    itemCode: string,
    quantity: number,
    unit: string
  ) => {
    const itemDataToDispatch = {
      itemCode: itemCode,
      itemQty: quantity,
      unitCode: unit,
    };

    dispatch(addToCart(sessionId, itemDataToDispatch));
    setShowAddToCart(true);
  };

  const addItemToShoppingListHandler = (
    sessionId: any,
    itemCode: string,
    quantity: number,
    unit: string
  ) => {
    const itemDataToDispatch = [
      {
        itemCode: itemCode,
        unitCode: unit,
        quantity: quantity,
      },
    ];
    dispatch(addItemInShoppingList(sessionId?.sessionId, itemDataToDispatch));
  };

  return (
    <React.Fragment>
      <Content>
        <div className="content-area">
          <Breadcrumb />
          <div className="row">
            <div className="col-lg-12 pr-0 pl-0 r-m-t">
              <ViewContainer className="pr-2">
                {!isMobile && (
                  <>
                    <div
                      onClick={() => {
                        setListView(true);
                      }}
                      style={{ cursor: "pointer" }}
                      className={!listView ? "GridIcon" : "ListIcon"}
                    >
                      <ListView className="primary-icon-2" />
                    </div>
                    <div
                      onClick={() => {
                        setListView(false);
                      }}
                      style={{ cursor: "pointer" }}
                      className={listView ? "GridIcon" : "ListIcon"}
                    >
                      <GridView className="primary-icon-2" />
                    </div>
                  </>
                )}
              </ViewContainer>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 pr-0 pl-0">
              {listView ? (
                <ProductList
                  productList={productList}
                  listView={listView}
                  products={products?.mostPopularViewAll}
                  loading={props.loading}
                  hasErrors={props.hasErrors}
                  onAddToCartHandler={addItemToCartHandler}
                  onAddItemToList={addItemToShoppingListHandler}
                  onQuantityChangeHandler={quantityChangeHandler}
                  onUnitChangeHandler={unitChangeHandler}
                  onAddToCartActon={setShowAddToCart}
                />
              ) : (
                <ProductsGrid
                  productList={productList}
                  listView={listView}
                  products={products?.mostPopularViewAll}
                  loading={props.loading}
                  hasErrors={props.hasErrors}
                  onAddToCartHandler={addItemToCartHandler}
                  onAddItemToList={addItemToShoppingListHandler}
                  onQuantityChangeHandler={quantityChangeHandler}
                  onUnitChangeHandler={unitChangeHandler}
                  onAddToCartActon={setShowAddToCart}
                />
              )}
              <AddItemToCart
                status={showAddToCart}
                onClose={setShowAddToCart}
              />
              <AddItemToShoppingList />
            </div>
          </div>
        </div>
      </Content>
      <LoadingOverlay active={loading} />
    </React.Fragment>
  );
};

export default MostPopularViewAll;

const Content = styled.div`
  margin-top: 50px;
  min-height: 80vh;
  @media (max-width: 550px) {
    margin-top: 112px;
  }
`;

const ViewContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-bottom: 10px;
`;
